
<!-- Кадастровый объект (объект оценки) -->

<template>

	<div class="main-container">

		<b-navbar class="p-0 mb-3">

			<b-navbar-brand class="p-0">
				<div class="d-flex align-items-center" style="gap: .75rem;">
					<b-button v-if="has_history" class="transparent" @click="go_back">

						<base-icon name="arrow long_left" />

					</b-button>

					<h3>{{ object_type }} {{ current_version.attrs.CadastralNumber }}</h3>
				</div>
			</b-navbar-brand>

		</b-navbar>

		<b-overlay :show="wait" class="object_desc main-container_content">
			<b-tabs class="blue-500 main-container" active-tab-class="main-container_content">
				<b-tab title="Основные характеристики" active>
					<digest :current_version="current_version" :geojson="geojson" :object_type_reference="object_type_reference" :category_reference="category_reference" :assignation_building_reference="assignation_building_reference" :assignation_type_reference="assignation_type_reference" :assignation_code_reference="assignation_code_reference"/>
					
					
				</b-tab>

				<b-tab title="Характеристики / ценообразующие факторы">

					<attrs_table class="pt-2" :data="current_version.attrs" :attrs="attrs" :attr_tags="attr_tags" :position_in_object_type_reference="position_in_object_type_reference" :key_parameter_type_reference="key_parameter_type_reference"/>

				</b-tab>

				<b-tab title="Входящие ЗУ" v-if="current_version.expanded_lands && current_version.expanded_lands.length > 0">

					<b-card no-body class="mt-2" v-for="el, ind in current_version.expanded_lands" :key="ind">

						<b-card-header header-tag="header" role="tab">

							<b-button size="sm" class="filter-button" variant="gray" block v-b-toggle="el.attrs.CadastralNumber" style="text-align: left;">{{ el.attrs.CadastralNumber }}</b-button>

						</b-card-header>

						<b-collapse :id="el.attrs.CadastralNumber" role="tabpanel">

							<attrs_table class="mt-2" :data="el.attrs" :attrs="attrs" :attr_tags="attr_tags" :position_in_object_type_reference="position_in_object_type_reference" :key_parameter_type_reference="key_parameter_type_reference"/>

						</b-collapse>

					</b-card>

				</b-tab>

				<b-tab title="Параметры расчета КС" v-if="
					current_version.group.cost_evaluation_comparative
					|| current_version.group.cost_evaluation_expensive
					|| current_version.group.cost_evaluation_profitable
					|| current_version.group.cost_evaluation_individual
				">

					<cost_evaluation class="mt-2" :object_id="id" :version="current_version" :correction_types="correction_types" :functional_sub_group_reference="functional_sub_group_reference" :attrs="attrs"/>

				</b-tab>

			</b-tabs>
		</b-overlay>

	</div>

</template>

<script>

import api from "../../../../api"
import digest from "./digest"

import attrs_table from "../../base_objects/object/attrs"
import cost_evaluation from "./cost_evaluation" 

export default
{
	components :
	{
		digest,
		
		attrs_table,
		cost_evaluation,
	},

	data()
	{
		return {

			service : "cadastral_objects",

			id : null,
			cadastral_number : null,
			data : { current_version : { group : {}, attrs : {}, base_attrs : {} } },

			version : {},

			attrs : [],
			attr_tags : [],

			diff : {},
			diff_version_names : {},

			geojson : null,

			object_type_reference : {},
			parcel_type_reference : {},
			category_reference : {},
			assignation_building_reference : {},
			position_in_object_type_reference : {},
			key_parameter_type_reference : {},
			assignation_type_reference : {},
			assignation_code_reference : {},
			functional_sub_group_reference : {},
			correction_types : [],

			wait : false,

		}
	},

	computed :
	{
		current_version() { return this.data.current_version },
		object_type()
		{
			return api.format_reference(this.object_type_reference, this.current_version.attrs.ObjectType, true)
		},

		is_parcel() { return this.current_version.attrs.ObjectType == "002001001000" },
		is_building() { return ! ( this.is_parcel || this.is_construction ) },
		is_construction() { return this.current_version.attrs.ObjectType == "002001004000" },

		has_history()
		{
			return window.history.length > 1
		},
	},

	mounted() 
	{
		this.id = this.$route.params.id
		this.cadastral_number = this.$route.params.cadastral_number

		return this.refresh()
	},

	methods :
	{
		refresh()
		{
			this.wait = true

			return api.call(this, "cadastral_objects", "get_full", { id : this.id, cadastral_number : this.cadastral_number },
				response =>
				{
					this.id = response.id
					this.attrs = api.sort_objects_array_by_key(response.attrs, "name")

					const refs_key = [
						"attrs.ObjectType",
						"attrs.Category",
						"attrs.createBuilding",
						"attrs.PositionInObject.Type",
						"attrs.Assignation.AssignationType",
						"attrs.AssignationCode",
						"attrs.functional_group"
					]

					const refs = {}

					response.attrs.forEach((attr) => {
						if (attr.reference && refs_key.includes(attr.key))
						{
							refs[attr.key] = attr.reference
						}
					})

					this.attr_tags = response.attr_tags
					this.object_type_reference = refs["attrs.ObjectType"]
					this.parcel_type_reference = response.parcel_type_reference
					this.category_reference = refs["attrs.Category"]
					this.assignation_building_reference = refs["attrs.createBuilding"]
					this.position_in_object_type_reference = refs["attrs.PositionInObject.Type"]
					this.key_parameter_type_reference = response.key_parameter_type_reference
					this.assignation_type_reference = refs["attrs.Assignation.AssignationType"]
					this.assignation_code_reference = refs["attrs.AssignationCode"]
					this.functional_sub_group_reference = refs["attrs.functional_group"]
					this.correction_types = response.correction_types
					this.diff = response.diff
					this.diff_version_names = response.diff_version_names
					this.geojson = response.geojson
					this.data = response.data
				})
				.then(() => { this.wait = false })
		},

		go_back()
		{
			api.back.go(this)
		},
	}
}

</script>

<style scoped>
* >>> .object_desc > .main-container > .tab-content
{
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
}
</style>

